import React, { useContext } from "react";
import I18nProvider from "./I18nProvider";

import gb from "./translations/gb-EN.json";
import jp from "./translations/ja-JP.json";
import { Locale } from "date-fns";

type lang = "gb" | "jp";

interface Translation {
  [key: string]: string;
}

interface Translations {
  analytics: Translation;
  calendar: Translation;
  core: Translation;
  error: Translation;
  forms: Translation;
  graphs: Translation;
  service: Translation;
  statuses: Translation;
  tableData: Translation;
  activity: Translation;
  eventTypes: Translation;
  transaction: Translation;
  itemization: Translation;
  allowedSourceIps: Translation;
  customConfigurations: Translation;
  confirmAPI: Translation;
  countries: Translation;
  homePage: Translation;
  profanity: Translation;
  blacklist: Translation;
  accountType: Translation;
  download: Translation;
  ott: Translation;
  contact: Translation;
}

const englishTranslations: Translations = gb;
const japaneseTranslations: Translations = jp;

export const translations = {
  gb: {
    ...englishTranslations.core,
    ...englishTranslations.error,
    ...englishTranslations.service,
    ...englishTranslations.tableData,
    ...englishTranslations.graphs,
    ...englishTranslations.statuses,
    ...englishTranslations.analytics,
    ...englishTranslations.calendar,
    ...englishTranslations.forms, //TODO break down translations to allow partial import... P.S. I really like this suggestion from 3 years ago, shall we do it?
    ...englishTranslations.activity,
    ...englishTranslations.eventTypes,
    ...englishTranslations.transaction,
    ...englishTranslations.itemization,
    ...englishTranslations.allowedSourceIps,
    ...englishTranslations.customConfigurations,
    ...englishTranslations.confirmAPI,
    ...englishTranslations.countries,
    ...englishTranslations.homePage,
    ...englishTranslations.profanity,
    ...englishTranslations.blacklist,
    ...englishTranslations.accountType,
    ...englishTranslations.download,
    ...englishTranslations.ott,
    ...englishTranslations.contact,
    dateLocale: "en",
  },
  jp: {
    ...japaneseTranslations.core,
    ...japaneseTranslations.error,
    ...japaneseTranslations.service,
    ...japaneseTranslations.tableData,
    ...japaneseTranslations.graphs,
    ...japaneseTranslations.statuses,
    ...japaneseTranslations.analytics,
    ...japaneseTranslations.calendar,
    ...japaneseTranslations.forms,
    ...japaneseTranslations.activity,
    ...japaneseTranslations.eventTypes,
    ...japaneseTranslations.transaction,
    ...japaneseTranslations.itemization,
    ...japaneseTranslations.allowedSourceIps,
    ...japaneseTranslations.customConfigurations,
    ...japaneseTranslations.confirmAPI,
    ...japaneseTranslations.countries,
    ...japaneseTranslations.homePage,
    ...japaneseTranslations.profanity,
    ...japaneseTranslations.blacklist,
    ...japaneseTranslations.accountType,
    ...japaneseTranslations.download,
    ...japaneseTranslations.ott,
    ...japaneseTranslations.contact,
    dateLocale: "ja",
  },
};

export const availableLangs = Object.keys(translations) as lang[];
export const I18nContext = React.createContext({
  lang: availableLangs[0],
  dateLocale: null as unknown as Locale,
  t: (s) => s,
  updateLocale: (lang: lang) => {},
  availableLangs: availableLangs,
});

export const useI18n = () => useContext(I18nContext);

export default I18nProvider;
